import { userShopITems } from "../../constants/jsonConstant";
import { useState, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Row, Col, Card, Button, Form, FormControl } from "react-bootstrap";
import ShopAdds from "../shopAds/ShopAdds";
import { useNavigate } from "react-router-dom";
import images from "../../constants/images";
import UserPropertyViewModel from "../../components/ShopViewModel/UserPropertyViewModel";
import Addtocartmodal from "../Addtocartmodal";
import { getAsset } from "../../helpers/helper";
import { useGetPropertyByIdQuery } from "../../features/property/propertyApiSlice";
import { useLazySearchPropertyCompanyByNameQuery } from "../../features/user/userApiSlice";

import noImagePlaceholder from "../../assets/images/dummy/no_image_placeholder.png";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import "./userpropertyitem.css";
const UserPropertyItems = ({
  itemData,
  propertyItems,
  back,
  shopid,
  shopData,
}) => {
  const Navigate = useNavigate();

  // ---- States ----
  const [showModel, setShowModel] = useState(1);
  const [show, setShow] = useState(0);
  const handleClose = () => setShow(0);
  const handleClosetwo = () => setShow(0);
  const [key, setKey] = useState("Items");
  const [showcategory, setShowcategory] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [itemsdata, setItemsData] = useState();
  const [propertysearch, setPropertysearch] = useState();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showoneModal, setShowoneModal] = useState(false);

  // ---- Modal Functions ----
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleShowModal = () => {
    setShowModal(true);
    setShow(0);
  };

  const handleCloses = () => {
    setShowoneModal(false);
  };

  const handleFocus = () => {
    setShowDropdown(true);
  };

  const handleBlur = () => {
    setTimeout(() => setShowDropdown(false), 100);
  };

  const handleTabSelect = (eventKey) => {
    if (eventKey === "tab1") {
      setShowoneModal(true);
    }
  };

  // ---- API Calls ----
  const [searchProperty] = useLazySearchPropertyCompanyByNameQuery();

  const filterProperty = async (e) => {
    if (!e || e.trim() === "") {
      setPropertysearch(undefined);
      return;
    }
    try {
      const response = await searchProperty(e).unwrap();
      setPropertysearch(response?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const { data: singlePropertyData } = useGetPropertyByIdQuery(show, {
    skip: !show,
  });

  useEffect(() => {
    if (singlePropertyData) {
      setItemsData(singlePropertyData?.data?.Property);
    }
  }, [singlePropertyData]);

  const displayData =
    propertysearch !== undefined
      ? propertysearch
      : propertyItems || itemData?.itemdata || [];

  // ---- Render ----
  return (
    <>
      <Addtocartmodal
        handleCloseModal={handleCloseModal}
        showModal={showModal}
      />
      

      <ShopAdds />

      <div className="me-3 ms-3 border-top" onBlur={() => setShowcategory(0)}>
        {/* Property View Modal */}
        <UserPropertyViewModel
          show={show}
          handleClosetwo={handleClosetwo}
          handleShowModal={handleShowModal}
          handleClose={handleClose}
          itemsdata={itemsdata}
        />

        {/* Tabs Section */}
        <div className="position-relative p-2">
          {/* ✅ Search Bar (visible & properly positioned) */}
          <div className="d-flex justify-content-end position-relative mt-1 mb-2">
            <Form
              className="position-absolute search-absolute"
              onFocus={handleFocus}
              onBlur={handleBlur}
            >
              <FormControl
                type="text"
                placeholder="Search"
                className="search-buing-area"
                name="subCategory"
                onChange={(e) => filterProperty(e.target.value)}
              />
            </Form>
          </div>

          {/* ✅ Tabs Section */}
          <Tabs
            activeKey={key}
            id="user-property-tabs"
            onSelect={(k) => handleTabSelect(k)}
            className="mb-3"
          >
            <Tab eventKey="Items" title="Items" className="jobviewhead">
              <div className="noscroll shop-scroll">
                <div className="row ps-2 pe-2">
                  {displayData?.length > 0 ? (
                    displayData.map((Items) => (
                      <Col xs={12} className="mb-4" key={Items?._id}>
                        <Card className="userProperty-card border-0 rounded-4 overflow-hidden shadow-sm mt-2">
                          <Row className="g-0 align-items-center">
                            {/* Image Section */}
                            <Col md={5}>
                              <div className="userProperty-img-container">
                                <Card.Img
                                  src={
                                    Items?.image?.[0]
                                      ? getAsset(Items.image[0])
                                      : noImagePlaceholder
                                  }
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = noImagePlaceholder;
                                  }}
                                  alt={Items?.subCategory}
                                  className="userProperty-img"
                                  crossOrigin="anonymous"
                                  loading="lazy"
                                />
                              </div>
                            </Col>

                            {/* Content Section */}
                            <Col md={7}>
                              <Card.Body className="p-4">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <Card.Title className="fw-bold text-capitalize mb-0">
                                    {Items?.subCategory}
                                  </Card.Title>
                                  <div className="userProperty-rating">
                                    ⭐⭐⭐⭐☆
                                  </div>
                                </div>

                                <Card.Text className="text-muted mb-3">
                                  {Items.description?.length > 160
                                    ? `${Items.description.substring(0, 160)}...read more`
                                    : Items.description}
                                </Card.Text>

                                <div className="text-primary fw-semibold mb-3 fs-5">
                                  {Items?.currency?.slice(0, 3)} :{" "}
                                  {Items?.price}
                                </div>

                                <Button
                                  variant="primary"
                                  className="w-100 fw-semibold py-2"
                                  onClick={() => setShow(Items?._id)}
                                >
                                  View
                                </Button>
                              </Card.Body>
                            </Col>
                          </Row>
                        </Card>
                      </Col>
                    ))
                  ) : (
                    <div className="text-center text-muted mt-5 mb-5 w-100">
                      <h5 className="fw-bold">No Data Found</h5>
                      <p>No properties match your search.</p>
                    </div>
                  )}
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default UserPropertyItems;
